"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./login.scss");
var ripple_1 = require("@material/ripple");
var textfield_1 = require("@material/textfield");
var snackbar_1 = require("@material/snackbar");
var iconMap = {
    password: "visibility_off",
    text: "visibility",
};
var textFields = [];
var toggleVisibility = function (ev) {
    var _a;
    if (ev instanceof KeyboardEvent && !(ev.key == "Enter" || ev.key == " ")) {
        return;
    }
    var button = ev.target;
    var targetField = (_a = button === null || button === void 0 ? void 0 : button.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector("input");
    if (targetField != null && button != null) {
        var attribute = targetField.getAttribute("type");
        attribute = attribute == "password" ? "text" : "password";
        targetField.setAttribute("type", attribute);
        button.innerHTML = iconMap[attribute];
    }
};
document.querySelectorAll(".mdc-text-field").forEach(function (f) {
    var field = new textfield_1.MDCTextField(f);
    field.listen("keyup", function (r) {
        validateForm();
    });
    textFields.push(field);
    new ripple_1.MDCRipple(f);
});
document
    .querySelectorAll(".vms-login-form__text-visibility-toggle")
    .forEach(function (t) {
    t.addEventListener("click", toggleVisibility);
    t.addEventListener("keyup", toggleVisibility);
});
var snackbarElement = document.querySelector(".mdc-snackbar");
if (snackbarElement) {
    var snackbar = new snackbar_1.MDCSnackbar(snackbarElement);
    snackbar.open();
}
var btnSubmit = document.querySelector("#btnSubmit");
var btnCancel = document.querySelector("#btnCancel");
btnCancel.onclick = function () {
    var _a;
    (_a = btnCancel.form) === null || _a === void 0 ? void 0 : _a.submit();
};
var validateForm = function () {
    var isValid = textFields
        .map(function (tf) { return tf.valid; })
        .reduce(function (acc, current) { return acc && current; }, true);
    isValid
        ? btnSubmit === null || btnSubmit === void 0 ? void 0 : btnSubmit.removeAttribute("disabled")
        : btnSubmit === null || btnSubmit === void 0 ? void 0 : btnSubmit.setAttribute("disabled", "true");
};
